import { required, confirmed, email, numeric } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import i18n from '@/i18n.js'

extend('required', {
  ...required,
  message: 'Dieses Feld wird benötigt'
})

extend('min', {
  validate: (value, args) => {
    return value.length >= args.length
  },
  params: ['length'],
  message: 'Dieses Feld benötigt mind. {length} Zeichen'
})

extend('max', {
  validate: (value, args) => {
    return value.length <= args.length
  },
  params: ['length'],
  message: 'Maximal {length} Zeichen erlaubt'
})

extend('email', {
  ...email,
  message: 'E-Mail ungültig'
})

extend('numeric', {
  ...numeric,
  message: 'Nur nummerische Werte erlaubt'
})

extend('phoneNumber', {
  ...required,
  validate: (value) => {
    return value.trim().match(/^\+?(?:[0-9 ]){9,16}[0-9]$/)
  },
  message: 'Telefonnr. ungültig'
})

extend('swissPhoneNumber', {
  ...required,
  validate: (value) => {
    return /^\+41(?:[0-9 ]{8,12}[0-9])$/.test(value.trim())
  },
  message: 'Diese Telefonnummer ist ungültig. Bei Problemen setzen Sie sich mit der Energieagentur St. Gallen in Verbindung: 058 228 71 71'
})

extend('confirmed', {
  ...confirmed,
  message: 'Passwörter müssen übereinstimmen'
})

extend('between', {
  ...confirmed,
  message: (_, { min, max }) => i18n.t('formError.between', { min, max }),
  validate: (value, { min, max }) => (Number(value) >= min && Number(value) <= max),
  params: ['min', 'max']
})

extend('esr', {
  validate: (value, args) => {
    return value.length >= 32
  },
  params: ['length'],
  message: 'Die ESR-Referenznummer benötigt 27 Zeichen.'
})

extend('iban', {
  message: 'Bitte geben Sie eine gültige IBAN ein',
  validate: (input) => {
    var CODE_LENGTHS = {
      AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29, /* eslint-disable-line */
      CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, /* eslint-disable-line */
      FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21, /* eslint-disable-line */
      HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, /* eslint-disable-line */
      LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, /* eslint-disable-line */
      MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29, /* eslint-disable-line */
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26 /* eslint-disable-line */
  }
  var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, '') // keep only alphanumeric characters
          var code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/) // match and capture (1) the country code, (2) the check digits, and (3) the rest
          var digits
  // check syntax and length
  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false
  }
  // rearrange country code and check digits, and convert chars to ints
  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
      return letter.charCodeAt(0) - 55
  })
  // final check
  return mod97(digits)
}
})

function mod97 (string) {
  var checksum = string.slice(0, 2); var fragment
  for (var offset = 2; offset < string.length; offset += 7) {
      fragment = String(checksum) + string.substring(offset, offset + 7)
      checksum = parseInt(fragment, 10) % 97
  }
  return checksum
}
